/*eslint-disable*/
import React, { Component } from 'react'
import AddTitleBar from '../../components/titleBar/add_titleBar'
import { InsertApproval } from '../../components/approvalConditionComponent/insertApproval'

export default class AddApprovalCondition extends Component {
    render() {
        return (
            <React.Fragment>
                <AddTitleBar Title="New Approval Condition" LinkName="/approval-condition" />
                <InsertApproval />
            </React.Fragment>
        )
    }
}
